// 死亡画面：Space でリスタート
import Phaser from 'phaser';

export class GameOverScene extends Phaser.Scene {
  constructor() {
    super('GameOverScene');
  }

  create(): void {
    const cx = this.scale.width / 2;
    const cy = this.scale.height / 2;
    this.add.rectangle(cx, cy, this.scale.width, this.scale.height, 0x000000, 0.7);
    this.add
      .text(cx, cy - 40, 'YOU DIED', {
        fontFamily: 'monospace',
        fontSize: '40px',
        color: '#ff5566',
      })
      .setOrigin(0.5);
    this.add
      .text(cx, cy + 24, 'Press SPACE to retry', {
        fontFamily: 'monospace',
        fontSize: '16px',
        color: '#aaaaaa',
      })
      .setOrigin(0.5);
    this.input.keyboard!.once('keydown-SPACE', () => {
      this.scene.stop('UIScene');
      this.scene.stop('WorldScene');
      this.scene.start('WorldScene');
      this.scene.launch('UIScene');
      this.scene.stop();
    });
  }
}
